import * as angular from 'angular';
import * as _ from 'lodash';
import numeral from 'numeral';
import swivel from 'swivel';

import { BigNumberComponent } from './ui/big-number/big-number-component';
import { ChartContainerComponent } from './ui/chart-container/chart-container-component';
import { ChartController } from './ui/chart/chart-controller';
import { LegacyChartDirective } from './ui/chart/chart-directive';
import { DraggableItemListComponent } from './ui/draggable-item-list/draggable-item-list-component';
import { DraggableItemComponent } from './ui/draggable-item/draggable-item-component';
import { DroppableTargetComponent } from './ui/droppable-target/droppable-target-component';
import { FillerbusterComponent } from './ui/fillerbuster/fillerbuster-component';
import { PivotConfigComponent } from './ui/pivot-config/pivot-config-component';
import { PivotTableSettingsComponent } from './ui/pivot-table-settings/pivot-table-settings-component';
import { PivotTableComponent } from './ui/pivot-table/pivot-table-component';
import { SettingsContextPanelComponent } from './ui/settings-context-panel/settings-context-panel-component';
import { ChartInterpolaterService } from './domain/chart-interpolater-service';
import { ChartSanitizerService } from './domain/chart-sanitizer-service';
import ChartThemeService from './domain/chart-theme-service';
import { ComponentsModule } from '~/core-app/components';
import { SharedServicesModule } from '../mode-shared-services';

export const chartModule = angular
  .module('mode.chart', ['ui.router', ComponentsModule, SharedServicesModule, 'ngCookies'])
  .constant('lodash', _)
  .constant('numeral', numeral)
  .constant('swivel', swivel)
  .controller('ChartController', ChartController)
  .component('modeChart', ChartContainerComponent)
  .component('settingsContextPanel', SettingsContextPanelComponent)
  .component('modePivotTable', PivotTableComponent)
  .component('modeBigNumber', BigNumberComponent)
  .component('pivotTableSettings', PivotTableSettingsComponent)
  .component('pivotConfig', PivotConfigComponent)
  .component('draggableItem', DraggableItemComponent)
  .component('draggableItemList', DraggableItemListComponent)
  .component('droppableTarget', DroppableTargetComponent)
  .component('fillerbuster', FillerbusterComponent)
  .directive('modeMultiChart', LegacyChartDirective)
  .service('ChartInterpolaterService', ChartInterpolaterService)
  .service('ChartThemeService', ChartThemeService)
  .service('ChartSanitizerService', ChartSanitizerService);
